import Reference from '@/fhirworks/types/Reference';
import merge from 'lodash/merge';
import DomainResource from './DomainResource';

/**
 * BN_MessageThread custom resource — a messaging conversation.
 *
 * `subject` is the client the thread is about; absent means a standalone thread with no
 * client context. `type` ('client' | 'internal') is deliberately NOT derived from `subject` —
 * an internal staff thread started from a client's chart has both a subject and staff-only
 * membership. `status` ('active' | 'closed') is the lifecycle; threads are closed, never
 * deleted. `lastMessageAt` is a denormalized sort key so the inbox can order threads without
 * loading their messages.
 *
 * Membership lives on BN_MessageThreadParticipant; the messages are Communication resources
 * pointing back here via the `thread` first-class extension.
 */
export default class BN_MessageThread extends DomainResource {
    static __className = 'BN_MessageThread';
    __objectStructure = {
        subject: Reference,
        type: String,
        status: String,
        topic: String,
        created: String,
        author: Reference,
        lastMessageAt: String,
    };

    constructor(constructJson, className = 'BN_MessageThread') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
